import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mt-20 relative z-10 flex items-start lg:grid-cols-1 lg:w-28 lg:grid lg:grid-cols-1 bg-gradient-to-b from-[#7A9CDA] to-[#4F71B0] text-white rounded-lg border-2 border-blue-500" }

import {EmailIcon} from "@/components/@icons"
import {LinkedinLogo, GithubLogo} from "@/components/@logos"
import SocialLinkItem from "@/views/HomeView/SocialLinks/SocialLinkItem.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'SocialLinks',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SocialLinkItem, { href: "https://github.com/huntski" }, {
      default: _withCtx(() => [
        _createVNode(_unref(GithubLogo))
      ]),
      _: 1
    }),
    _createVNode(SocialLinkItem, { href: "mailto:wieberanzijn@gmail.com" }, {
      default: _withCtx(() => [
        _createVNode(_unref(EmailIcon))
      ]),
      _: 1
    }),
    _createVNode(SocialLinkItem, { href: "https://www.linkedin.com/in/wiebe-ranzijn-908619183/" }, {
      default: _withCtx(() => [
        _createVNode(_unref(LinkedinLogo))
      ]),
      _: 1
    })
  ]))
}
}

})